module.exports = {
  URL: 'https://server.highstakesgolfpools.com/',
};
